import axios from "axios";
import { buildAuthHeaders } from "../buildAuthHeaders";
import { rootUrl } from "../rootUrl";

type UpdateClientResponse = {
  id: string;
};

export type UpdateClientRequest = {
  website?: string;
  logo?: string;
};

const endpoint = `/client/update`;

export const patchUpdateClient = async (
  body: UpdateClientRequest,
  accessToken: string
): Promise<UpdateClientResponse> => {
  const { data } = await axios.patch<UpdateClientResponse>(
    `${rootUrl}${endpoint}`,
    body,
    buildAuthHeaders(accessToken)
  );
  return data;
};
